// ─── 岗位分类 ───────────────────────────────────────────────────────────────
export interface JobCategory {
  id: string;
  name: string;
  icon: string;
  color: string;
  sort: number;
  employeeCount: number;
  description: string;
  enabled: boolean;
}

export const jobCategories: JobCategory[] = [
  { id: 'jc1', name: '销售', icon: 'ri-line-chart-line', color: '#10b981', sort: 1, employeeCount: 48, description: '负责客户开发、商机跟进与成单转化', enabled: true },
  { id: 'jc2', name: '客服', icon: 'ri-customer-service-2-line', color: '#0ea5e9', sort: 2, employeeCount: 35, description: '负责客户咨询、投诉处理与满意度提升', enabled: true },
  { id: 'jc3', name: '运营', icon: 'ri-broadcast-line', color: '#f59e0b', sort: 3, employeeCount: 29, description: '负责内容运营、用户增长与数据分析', enabled: true },
  { id: 'jc4', name: '市场', icon: 'ri-megaphone-line', color: '#8b5cf6', sort: 4, employeeCount: 22, description: '负责品牌推广、投放策略与市场活动', enabled: true },
  { id: 'jc5', name: '人事', icon: 'ri-team-line', color: '#ec4899', sort: 5, employeeCount: 17, description: '负责招聘筛选、员工管理与绩效评估', enabled: true },
  { id: 'jc6', name: '财务', icon: 'ri-money-cny-circle-line', color: '#14b8a6', sort: 6, employeeCount: 14, description: '负责账务处理、报销审核与财务分析', enabled: true },
  { id: 'jc7', name: '法务', icon: 'ri-scales-line', color: '#64748b', sort: 7, employeeCount: 8, description: '负责合同审查、合规风控与法律咨询', enabled: true },
  { id: 'jc8', name: '技术支持', icon: 'ri-tools-line', color: '#f97316', sort: 8, employeeCount: 11, description: '负责系统维护、技术答疑与故障处理', enabled: true },
];

// ─── 能力标签 ────────────────────────────────────────────────────────────────
export interface AbilityTag {
  id: string;
  name: string;
  category: string;
  color: string;
  sort: number;
  usageCount: number;
  description: string;
}

export const abilityTags: AbilityTag[] = [
  { id: 'at1', name: '自然语言理解', category: '核心AI', color: '#0ea5e9', sort: 1, usageCount: 156, description: '理解并解析用户意图与情感' },
  { id: 'at2', name: '多轮对话', category: '核心AI', color: '#0ea5e9', sort: 2, usageCount: 142, description: '支持连续上下文跨轮对话' },
  { id: 'at3', name: '知识检索', category: '核心AI', color: '#0ea5e9', sort: 3, usageCount: 98, description: '基于知识库的精准问答检索' },
  { id: 'at4', name: '情绪识别', category: '情感智能', color: '#ec4899', sort: 4, usageCount: 87, description: '实时感知用户情绪状态并调整策略' },
  { id: 'at5', name: '情感安抚', category: '情感智能', color: '#ec4899', sort: 5, usageCount: 76, description: '针对负面情绪的专业疏导与引导' },
  { id: 'at6', name: '报表生成', category: '数据分析', color: '#10b981', sort: 6, usageCount: 65, description: '自动生成结构化数据报表' },
  { id: 'at7', name: '数据洞察', category: '数据分析', color: '#10b981', sort: 7, usageCount: 59, description: '从数据中提炼业务洞察与建议' },
  { id: 'at8', name: 'CRM集成', category: '系统集成', color: '#f59e0b', sort: 8, usageCount: 112, description: '与主流CRM系统无缝对接' },
  { id: 'at9', name: '工单系统', category: '系统集成', color: '#f59e0b', sort: 9, usageCount: 93, description: '自动创建与更新工单流转' },
  { id: 'at10', name: '合同起草', category: '法务能力', color: '#8b5cf6', sort: 10, usageCount: 31, description: '根据模板和参数生成合同草稿' },
  { id: 'at11', name: '沟通话术', category: '销售能力', color: '#f97316', sort: 11, usageCount: 134, description: '专业销售话术库与场景应对' },
  { id: 'at12', name: '商机识别', category: '销售能力', color: '#f97316', sort: 12, usageCount: 98, description: '从对话中识别潜在商机信号' },
];

// ─── 行业标签 ────────────────────────────────────────────────────────────────
export interface IndustryTag {
  id: string;
  name: string;
  icon: string;
  color: string;
  sort: number;
  usageCount: number;
  description: string;
}

export const industryTags: IndustryTag[] = [
  { id: 'it1', name: '电商零售', icon: 'ri-shopping-cart-2-line', color: '#f97316', sort: 1, usageCount: 89, description: '适用于电商平台、在线零售商' },
  { id: 'it2', name: '金融保险', icon: 'ri-bank-line', color: '#10b981', sort: 2, usageCount: 67, description: '适用于银行、保险、证券机构' },
  { id: 'it3', name: '医疗健康', icon: 'ri-heart-pulse-line', color: '#ef4444', sort: 3, usageCount: 54, description: '适用于医院、诊所、健康管理' },
  { id: 'it4', name: '教育培训', icon: 'ri-graduation-cap-line', color: '#8b5cf6', sort: 4, usageCount: 72, description: '适用于学校、培训机构、在线教育' },
  { id: 'it5', name: '房产中介', icon: 'ri-building-line', color: '#f59e0b', sort: 5, usageCount: 43, description: '适用于房产销售、租赁、中介' },
  { id: 'it6', name: 'SaaS软件', icon: 'ri-code-box-line', color: '#0ea5e9', sort: 6, usageCount: 91, description: '适用于企业软件、云服务商' },
  { id: 'it7', name: '餐饮连锁', icon: 'ri-restaurant-2-line', color: '#14b8a6', sort: 7, usageCount: 38, description: '适用于连锁餐厅、外卖平台' },
  { id: 'it8', name: '汽车行业', icon: 'ri-car-line', color: '#64748b', sort: 8, usageCount: 29, description: '适用于汽车销售、维修、租赁' },
  { id: 'it9', name: '旅游酒店', icon: 'ri-hotel-line', color: '#ec4899', sort: 9, usageCount: 35, description: '适用于酒店、旅行社、OTA平台' },
  { id: 'it10', name: '人力资源', icon: 'ri-team-line', color: '#a855f7', sort: 10, usageCount: 47, description: '适用于猎头、HR SaaS、外包服务' },
];

// ─── 数字员工 ────────────────────────────────────────────────────────────────
export interface EmployeeScore {
  dimension: string;
  score: number;
  maxScore: number;
}

export type CommissionType = 'per_hire' | 'sales_pct' | 'milestone' | 'fixed_only' | 'satisfaction_bonus' | 'custom_pct' | 'per_unit';

export interface MilestoneItem {
  id: string;
  label: string;
  target: number;
  current: number;
  unit: string;
  reward: number;
  triggered: boolean;
  deadline?: string;
}

export interface PerUnitItem {
  id: string;
  label: string;
  unit: string;
  price: number;
  count?: number;
}

export interface FailedTicket {
  id: string;
  time: string;
  errorType: string;
  errorDetail: string;
  duration: string;
  retried: boolean;
  resolved: boolean;
  triggerInput: string;
}

export interface CommissionConfig {
  type: CommissionType;
  salesPct?: number;
  perHireAmount?: number;
  milestoneDesc?: string;
  milestoneItems?: MilestoneItem[];
  satisfactionThreshold?: number;
  satisfactionBonus?: number;
  customPct?: number;
  perUnitItems?: PerUnitItem[];
}

export interface KnowledgeBaseAccuracy {
  name: string;
  type: string;
  queries: number;
  accuracy: number;
  trend: 'up' | 'down' | 'stable';
  trendValue: number;
}

export interface KnowledgeStats {
  totalQueries: number;
  overallAccuracy: number;
  topMissCategory: string;
  weeklyAccuracy: number[];
  knowledgeBases: KnowledgeBaseAccuracy[];
}

export interface WorkCase {
  id: string;
  title: string;
  industry: string;
  result: string;
  description: string;
  date: string;
}

export interface BossReview {
  id: string;
  boss: string;
  company: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export interface WorkflowItem {
  name: string;
  type: string;
  totalRuns: number;
  successRate: number;
  avgDuration: string;
  errorTypes: string[];
  status: 'healthy' | 'warning' | 'error';
  failedTickets?: FailedTicket[];
}

export interface WorkflowStats {
  totalRuns: number;
  overallSuccessRate: number;
  avgDuration: string;
  failedCount: number;
  weeklySuccessRate: number[];
  workflows: WorkflowItem[];
}

// ─── 团队聘用配置 ─────────────────────────────────────────────────────────────
export interface TeamHireRole {
  id: string;
  title: string;     // 角色名称，如 "主客服"、"副客服"
  count: number;     // 数量
  note?: string;     // 备注说明
  required: boolean; // 是否必须
}

export interface TeamHirePlan {
  id: string;
  name: string;        // 方案名称，如 "标准客服团队"
  description: string; // 方案描述
  roles: TeamHireRole[]; // 团队角色构成
  discount?: number;   // 团队折扣（0-1，如 0.9 表示九折）
  badge?: string;      // 推荐标签，如 "最受欢迎"
  isDefault?: boolean; // 是否为默认推荐方案
  /** 推荐理由，帮助客户快速了解方案价值 */
  recommendReasons?: string[];
  /** 适用场景，明确该方案最匹配的使用情景 */
  applicableScenarios?: string[];
}

export interface EmployeeTeamConfig {
  /** 是否允许单独聘用，false = 只能通过团队方案聘用 */
  canHireAlone: boolean;
  /** 不能单独聘用时的提示文案 */
  partnerHint?: string;
  /** 是否允许同岗位聘用多名 */
  multiHireEnabled: boolean;
  /** 允许同时聘用的最大数量（multiHireEnabled=true 时有效） */
  maxMultiHireCount?: number;
  /** 团队方案列表 */
  plans?: TeamHirePlan[];
}

export interface DigitalEmployee {
  id: string;
  name: string;
  avatar: string;
  jobCategory: string;
  title: string;
  gender: 'male' | 'female' | 'neutral';
  introduction: string;
  personality: string;
  salary: number;
  salaryUnit: 'month' | 'task';
  commission: number;
  commissionConfig?: CommissionConfig;
  status: 'published' | 'draft' | 'review' | 'offline';
  industries: string[];
  abilityTags: string[];
  trialDays: number;
  identity: string;
  coreMission: string;
  deliverySample: string;
  successMetrics: string;
  scores: EmployeeScore[];
  performance: {
    totalTasks: number;
    satisfactionRate: number;
    avgResponseTime: string;
    onlineHours: number;
  };
  knowledgeStats: KnowledgeStats;
  workflowStats: WorkflowStats;
  workCases: WorkCase[];
  bossReviews: BossReview[];
  factoryCapabilities: string[];
  dependencyLibs: string[];
  hasPerformanceReport: boolean;
  hasWorkReport: boolean;
  hasGrowthReport: boolean;
  createdAt: string;
  updatedAt: string;
  // 人设配置（可选，未配置时使用默认值）
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  personaConfig?: Record<string, any>;
  industryTags?: string[];
  /** 独立的用户端显示开关（与发布状态解耦，false = 强制不在用户端显示） */
  visibleInUserSide?: boolean;
  /** 等级 LV.1-10（与员工成长关联） */
  level?: number;
  /** 团队聘用 & 多名聘用配置 */
  teamConfig?: EmployeeTeamConfig;
  /**
   * 定向分配租户 ID 列表
   * - undefined / 空数组 = 公开，所有租户可见
   * - 有值 = 仅列表内的租户可在用户端看到此员工
   */
  targetTenantIds?: string[];
}

export const marketplaceEmployees: DigitalEmployee[] = [
  {
    id: 'de1',
    name: '李晓慧',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20AI%20assistant%20avatar%20with%20warm%20smile%2C%20clean%20minimal%20background%2C%20soft%20lighting%2C%20high%20quality%20portrait%2C%20friendly%20expression%2C%20modern%20style&width=80&height=80&seq=emp1&orientation=squarish',
    jobCategory: '客服',
    title: '高级客服专员',
    gender: 'female',
    introduction: '晓慧是一位经验丰富的客服专员，专注于电商与SaaS场景下的客户服务，以高情商和专业知识著称，能够在30秒内精准识别用户需求并给出解决方案。',
    personality: '温暖、耐心、专业、细致',
    salary: 2800,
    salaryUnit: 'month',
    commission: 0,
    commissionConfig: {
      type: 'satisfaction_bonus',
      satisfactionThreshold: 95,
      satisfactionBonus: 800,
    },
    status: 'published',
    industries: ['电商零售', 'SaaS软件'],
    abilityTags: ['自然语言理解', '多轮对话', '情绪识别', '情感安抚', 'CRM集成'],
    trialDays: 7,
    identity: '我是一名专业的数字客服员工，专注于提供高质量的客户服务体验，帮助企业建立和维护良好的客户关系。',
    coreMission: '通过精准理解客户需求，快速解决问题，提升客户满意度，降低企业客服成本，实现客户留存率最大化。',
    deliverySample: '用户反映订单延误 → 晓慧立即调取订单状态 → 情感安抚 + 解释原因 → 提供补偿方案 → 确认客户满意 → 全程记录工单 → 满意率 96.8%',
    successMetrics: '首次解决率 &gt;92%，平均响应时间 &lt;30s，客户满意度 &gt;4.8/5，升级率 &lt;5%',
    scores: [
      { dimension: '沟通能力', score: 96, maxScore: 100 },
      { dimension: '问题解决', score: 91, maxScore: 100 },
      { dimension: '情绪管理', score: 98, maxScore: 100 },
      { dimension: '知识掌握', score: 89, maxScore: 100 },
      { dimension: '响应速度', score: 94, maxScore: 100 },
    ],
    performance: { totalTasks: 12840, satisfactionRate: 96.8, avgResponseTime: '22s', onlineHours: 8760 },
    knowledgeStats: { totalQueries: 18420, overallAccuracy: 94.2, topMissCategory: '退换货政策细则', weeklyAccuracy: [91.5, 92.8, 93.1, 94.0, 93.7, 94.2], knowledgeBases: [{ name: '产品服务知识库', type: '产品文档', queries: 8640, accuracy: 96.5, trend: 'up', trendValue: 1.8 }, { name: '退换货政策库', type: '政策规则', queries: 4820, accuracy: 89.3, trend: 'stable', trendValue: 0.2 }, { name: '常见问题FAQ', type: '问答对', queries: 3210, accuracy: 97.8, trend: 'up', trendValue: 0.5 }, { name: '客诉处理手册', type: '流程文档', queries: 1750, accuracy: 92.1, trend: 'down', trendValue: 1.1 }] },
    workflowStats: { totalRuns: 26340, overallSuccessRate: 97.6, avgDuration: '1.8s', failedCount: 632, weeklySuccessRate: [96.8, 97.1, 97.4, 97.2, 97.8, 97.6], workflows: [
      { name: '用户意图识别流', type: '意图识别', totalRuns: 12840, successRate: 98.9, avgDuration: '0.6s', errorTypes: ['意图模糊', '超时'], status: 'healthy', failedTickets: [
        { id: 'ft_xh1', time: '2026-03-21 11:05', errorType: '意图模糊', errorDetail: '用户输入"我想问一下那个东西"，无法识别指代对象，意图置信度仅0.32', duration: '0.8s', retried: false, resolved: false, triggerInput: '"我想问一下那个东西"' },
        { id: 'ft_xh2', time: '2026-03-20 14:18', errorType: '超时', errorDetail: '当前并发请求数达峰值(180qps)，意图识别超过2s阈值', duration: '2.3s', retried: true, resolved: true, triggerInput: '客户反馈"商品包装破损需要退换"，触发工单创建' },
      ]},
      { name: '工单自动创建流', type: '系统集成', totalRuns: 6420, successRate: 96.2, avgDuration: '2.1s', errorTypes: ['CRM接口超时'], status: 'warning', failedTickets: [
        { id: 'ft_xh3', time: '2026-03-22 09:30', errorType: 'CRM接口超时', errorDetail: 'HubSpot CRM API /tickets/create 超过5s未响应，工单创建失败，客户问题未被记录', duration: '5.1s', retried: true, resolved: false, triggerInput: '客户反馈"商品包装破损需要退换"，触发工单创建' },
        { id: 'ft_xh4', time: '2026-03-21 17:42', errorType: 'CRM接口超时', errorDetail: 'CRM系统维护期间(17:30-18:00)接口不可用', duration: '5.0s', retried: false, resolved: true, triggerInput: '客户投诉"物流信息3天未更新"' },
        { id: 'ft_xh5', time: '2026-03-19 10:15', errorType: 'CRM接口超时', errorDetail: '网络抖动导致CRM API响应延迟，超过重试上限', duration: '6.2s', retried: true, resolved: true, triggerInput: '客户询问"订单状态为何显示异常"' },
      ]},
      { name: '客户满意度收集流', type: '数据采集', totalRuns: 4380, successRate: 99.1, avgDuration: '0.9s', errorTypes: ['客户未响应'], status: 'healthy', failedTickets: [
        { id: 'ft_xh6', time: '2026-03-18 13:00', errorType: '客户未响应', errorDetail: '满意度收集消息发出后48小时内客户无任何回复，系统标记为无效', duration: '48h超时', retried: false, resolved: false, triggerInput: '工单关闭后自动触发满意度问卷' },
      ]},
      { name: '升级预警触发流', type: '预警监控', totalRuns: 2700, successRate: 95.8, avgDuration: '3.4s', errorTypes: ['阈值配置偏差', '接口波动'], status: 'warning', failedTickets: [
        { id: 'ft_xh7', time: '2026-03-20 16:55', errorType: '阈值配置偏差', errorDetail: '预警情绪分阈值设为0.85，但该客户情绪值0.84未触发升级，实际情况已需人工介入', duration: '3.1s', retried: false, resolved: false, triggerInput: '客户多次表达"非常愤怒"情绪，触发预警判断' },
        { id: 'ft_xh8', time: '2026-03-17 15:20', errorType: '接口波动', errorDetail: '升级通知Webhook在流量高峰期返回503，导致升级通知未发出', duration: '4.8s', retried: true, resolved: true, triggerInput: '系统检测到VIP客户连续3次投诉同一问题' },
      ]},
    ]},
    workCases: [
      { id: 'wc1', title: '电商大促期间客服保障', industry: '电商零售', result: '处理3200+工单，满意率98.2%', description: '在双11期间独立处理超3200条客服工单，零升级，客户好评率98.2%，相比人工客服效率提升6倍。', date: '2026-01' },
      { id: 'wc2', title: 'SaaS客户流失预警挽回', industry: 'SaaS软件', result: '挽回12家企业客户续费', description: '通过分析客户使用数据和沟通记录，主动识别12家续费意愿低的企业客户，精准进行挽留沟通，成功保留年费 ¥48万。', date: '2026-02' },
    ],
    bossReviews: [
      { id: 'br1', boss: '张总', company: '某跨境电商平台', avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20business%20person%20avatar%2C%20clean%20background%2C%20portrait&width=40&height=40&seq=boss1&orientation=squarish', rating: 5, content: '晓慧上线后，我们的客服团队从12人缩减到3人，成本降低75%，同时客户满意度反而从91%提升到96%，超出预期。', date: '2026-03-08' },
      { id: 'br2', boss: '李主任', company: '某SaaS公司', avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20business%20person%20avatar%2C%20clean%20background%2C%20portrait&width=40&height=40&seq=boss2&orientation=squarish', rating: 5, content: '情绪处理能力特别强，几个之前我们最难搞的老客户投诉，都被她轻松化解了，这是人工客服很难做到的。', date: '2026-02-14' },
    ],
    factoryCapabilities: ['自然语言理解', '多轮对话', '情绪识别', '情感安抚'],
    dependencyLibs: ['NLP引擎 v3.2', '知识检索库 v2.1', '情感模型 v1.8', 'CRM API适配器'],
    hasPerformanceReport: true,
    hasWorkReport: true,
    hasGrowthReport: true,
    createdAt: '2024-06-01',
    updatedAt: '2026-02-20',
    teamConfig: {
      canHireAlone: true,
      multiHireEnabled: true,
      maxMultiHireCount: 5,
      plans: [
        {
          id: 'tp1',
          name: '标准客服团队',
          description: '适合中型电商企业，覆盖日常咨询、投诉处理与售后跟进全流程',
          badge: '最受欢迎',
          isDefault: true,
          discount: 0.9,
          roles: [
            { id: 'tr1', title: '主客服', count: 2, required: true, note: '负责核心咨询与投诉处理' },
            { id: 'tr2', title: '售后专员', count: 1, required: true, note: '专门处理退换货与物流追踪' },
            { id: 'tr3', title: '值班客服', count: 1, required: false, note: '夜班及节假日覆盖' },
          ],
          recommendReasons: [
            '主客服+售后专员角色互补，形成服务闭环，首次解决率比单岗位提升28%',
            '可选值班客服覆盖夜间及节假日，实现7×24h服务无死角',
            '团队九折优惠，比逐一聘用节省10%成本',
          ],
          applicableScenarios: [
            '日均咨询量200~800条的中型电商店铺',
            '有稳定售后需求、退换货比例>5%的品类',
            '需要兼顾夜间客服覆盖的跨时区运营场景',
          ],
        },
        {
          id: 'tp2',
          name: '大促保障团队',
          description: '专为双11、618等大促活动设计，高并发下确保响应速度不掉线',
          badge: '大促专属',
          discount: 0.85,
          roles: [
            { id: 'tr4', title: '主客服', count: 4, required: true, note: '大促期间并行处理' },
            { id: 'tr5', title: '售后专员', count: 2, required: true, note: '专项处理退货高峰' },
            { id: 'tr6', title: '质检专员', count: 1, required: false, note: '实时监控服务质量' },
          ],
          recommendReasons: [
            '4名主客服并行处理，大促期间并发量翻4倍也不掉线',
            '2名售后专员专项处理退货高峰，退款时效控制在24h内',
            '质检专员实时监控服务质量，异常工单自动预警',
            '8.5折团队折扣，大促期间成本最优解',
          ],
          applicableScenarios: [
            '双11、618、99大促等流量洪峰时期',
            '日咨询量临时暴涨10倍以上的爆款活动期',
            '对服务质量有严格SLA承诺的品牌旗舰店',
          ],
        },
        {
          id: 'tp-cs3',
          name: '售后保障团队',
          description: '售后全周期保障，技术问题快速响应，提升客户满意度与复购率',
          roles: [
            { id: 'tr-cs3-1', title: '售后专员', count: 1, required: true, note: '售后工单处理与回访' },
            { id: 'tr-cs3-2', title: '技术支持', count: 1, required: false, note: '技术问题排查与解决' },
          ],
        },
        {
          id: 'tp-cs4',
          name: '电商运营团队',
          description: '覆盖电商核心运营场景，从店铺运营、优化到售前客服一体化管理',
          badge: '推荐组合',
          discount: 0.88,
          roles: [
            { id: 'tr-cs4-1', title: '电商运营', count: 1, required: true, note: '店铺活动策划与推广' },
            { id: 'tr-cs4-2', title: '优化师', count: 1, required: true, note: '商品标题/主图/转化率优化' },
            { id: 'tr-cs4-3', title: '客服', count: 1, required: true, note: '售前咨询与订单处理' },
          ],
        },
      ],
    },
  },
  {
    id: 'de2',
    name: '梁明哲',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20AI%20sales%20assistant%20avatar%2C%20confident%20smile%2C%20clean%20minimal%20background%2C%20sharp%20professional%20look%2C%20modern%20portrait&width=80&height=80&seq=emp2&orientation=squarish',
    jobCategory: '销售',
    title: '资深销售顾问',
    gender: 'male',
    introduction: '明哲是一位经验丰富的B2B销售顾问，深谙企业采购决策链，擅长从冷启动到成单的全流程跟进，对各类拒绝话术有丰富的应对经验。',
    personality: '自信、积极、逻辑清晰、结果导向',
    salary: 0,
    salaryUnit: 'task',
    commission: 15,
    commissionConfig: {
      type: 'sales_pct',
      salesPct: 15,
    },
    status: 'published',
    industries: ['SaaS软件', '金融保险', '人力资源'],
    abilityTags: ['沟通话术', '商机识别', '多轮对话', 'CRM集成', '数据洞察'],
    trialDays: 14,
    identity: '我是一名专业的数字销售员工，通过系统化的销售方法论和精准的客户分析，帮助企业建立可持续的销售增长引擎。',
    coreMission: '识别高质量商机，通过专业销售顾问式对话推进商机转化，最终实现成单，并维护客户关系促进复购。',
    deliverySample: '触达潜在客户 → 快速建立信任 → 挖掘痛点需求 → 定制化方案呈现 → 处理异议 → 推动决策 → 促成成单 → 转介绍',
    successMetrics: '商机转化率 &gt;18%，平均成单周期 &lt;21天，客户满意度 &gt;4.7/5，复购率 &gt;65%',
    scores: [
      { dimension: '销售话术', score: 97, maxScore: 100 },
      { dimension: '商机判断', score: 93, maxScore: 100 },
      { dimension: '异议处理', score: 95, maxScore: 100 },
      { dimension: '需求挖掘', score: 91, maxScore: 100 },
      { dimension: '成单能力', score: 89, maxScore: 100 },
    ],
    performance: { totalTasks: 4560, satisfactionRate: 94.2, avgResponseTime: '45s', onlineHours: 7200 },
    knowledgeStats: { totalQueries: 9840, overallAccuracy: 91.7, topMissCategory: '竞品对比细节', weeklyAccuracy: [88.2, 89.5, 90.8, 91.0, 91.4, 91.7], knowledgeBases: [{ name: '销售话术知识库', type: '话术文档', queries: 4560, accuracy: 95.3, trend: 'up', trendValue: 2.1 }, { name: '产品功能说明库', type: '产品文档', queries: 2780, accuracy: 93.6, trend: 'up', trendValue: 0.8 }, { name: '竞品分析资料库', type: '外部文档', queries: 1620, accuracy: 82.4, trend: 'down', trendValue: 2.3 }, { name: '客户案例库', type: '案例文档', queries: 880, accuracy: 96.8, trend: 'stable', trendValue: 0.1 }] },
    workflowStats: { totalRuns: 12480, overallSuccessRate: 95.4, avgDuration: '2.6s', failedCount: 574, weeklySuccessRate: [93.2, 94.0, 94.8, 95.1, 95.6, 95.4], workflows: [{ name: '商机评分流', type: '评分模型', totalRuns: 4560, successRate: 97.2, avgDuration: '1.4s', errorTypes: ['数据缺失'], status: 'healthy' }, { name: '跟进策略推荐流', type: '策略生成', totalRuns: 3840, successRate: 94.5, avgDuration: '3.2s', errorTypes: ['策略库超时', '匹配失败'], status: 'warning' }, { name: '成单概率预测流', type: '预测分析', totalRuns: 2400, successRate: 96.8, avgDuration: '2.0s', errorTypes: ['特征缺失'], status: 'healthy' }, { name: '客户画像生成流', type: '数据分析', totalRuns: 1680, successRate: 92.3, avgDuration: '4.1s', errorTypes: ['数据源异常', '字段匹配错误'], status: 'warning' }] },
    workCases: [
      { id: 'wc3', title: '某SaaS企业线索转化项目', industry: 'SaaS软件', result: '3个月GMV增长220%', description: '接入300条冷线索，通过系统化话术跟进，3个月内成单54笔，GMV达 ¥128万，较人工团队提升220%。', date: '2026-01' },
    ],
    bossReviews: [
      { id: 'br3', boss: '王总', company: '某HR SaaS', avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20executive%20avatar%2C%20clean%20background%2C%20confident%20expression&width=40&height=40&seq=boss3&orientation=squarish', rating: 5, content: '明哲的成单率比我最好的销售还高8个百分点，而且完全不需要管理，24小时在线，真的是神器。', date: '2026-03-15' },
    ],
    factoryCapabilities: ['沟通话术', '商机识别', '多轮对话', '异议处理'],
    dependencyLibs: ['销售话术库 v4.1', 'NLP引擎 v3.2', 'CRM API适配器', '商机评分模型 v2.0'],
    hasPerformanceReport: true,
    hasWorkReport: true,
    hasGrowthReport: false,
    createdAt: '2024-08-15',
    updatedAt: '2026-01-30',
    teamConfig: {
      canHireAlone: false,
      partnerHint: '我需要有数据分析搭子才能最大化发挥价值，单独工作时成单效率会降低40%哦',
      multiHireEnabled: false,
      plans: [
        {
          id: 'tp3',
          name: '销售铁三角',
          description: '经典销售组合：开拓+跟进+运营，形成完整销售闭环，GMV增速提升3倍',
          badge: '推荐组合',
          isDefault: true,
          discount: 0.88,
          roles: [
            { id: 'tr7', title: '明哲（销售顾问）', count: 1, required: true, note: '负责商机开拓与成单' },
            { id: 'tr8', title: '数据运营专员', count: 1, required: true, note: '配合分析销售数据，优化话术' },
            { id: 'tr9', title: '客户成功经理', count: 1, required: false, note: '负责成单后的客户维护' },
          ],
          recommendReasons: [
            '明哲单独工作成单效率降低40%，搭配数据运营专员后胜率显著提升',
            '客户成功经理负责售后维护，复购率从65%提升至82%',
            '三角互补形成完整销售闭环，比单独聘用三名成员便宜12%',
          ],
          applicableScenarios: [
            '需要数据驱动话术优化的B2B SaaS销售团队',
            '客单价高、决策链长的企业级产品销售',
            '对复购率和客户续约有强依赖的订阅制业务',
          ],
        },
        {
          id: 'tp-sale2',
          name: 'AI外呼获客团队',
          description: '以 AI 外呼为核心的高效获客组合，覆盖拨出执行与意向分析全链路',
          badge: '推荐组合',
          roles: [
            { id: 'tr-sale2-1', title: '外呼专员', count: 1, required: true, note: '负责批量外呼与脚本执行' },
            { id: 'tr-sale2-2', title: '意向分析员', count: 1, required: true, note: '实时分析通话意向并打标' },
          ],
        },
        {
          id: 'tp-sale3',
          name: '智能销售团队',
          description: '从线索猎取到最终成交的完整销售闭环，覆盖外呼、邀约、跟进全过程',
          badge: '最受欢迎',
          discount: 0.9,
          roles: [
            { id: 'tr-sale3-1', title: '猎手', count: 1, required: true, note: '线索获取与资质筛选' },
            { id: 'tr-sale3-2', title: '外呼专员', count: 1, required: true, note: '电话接触与需求确认' },
            { id: 'tr-sale3-3', title: '邀约专员', count: 1, required: true, note: '会议/演示预约' },
            { id: 'tr-sale3-4', title: '客户经理', count: 1, required: true, note: '商务谈判与成交跟进' },
          ],
          recommendReasons: [
            '四岗分工协作，每个节点专人专职，商机转化率比全链路单岗高出35%',
            '猎手+外呼形成自动化线索漏斗，每周可处理2000+原始线索',
            '邀约专员专项提升演示预约率，客户到场率超60%',
          ],
          applicableScenarios: [
            '有大量冷线索需要批量激活的B2B企业',
            '销售团队人力不足、希望用AI快速补齐链路的成长期公司',
            '产品需要演示驱动决策的技术型企业',
          ],
        },
      ],
    },
  },
  {
    id: 'de3',
    name: '雅婷',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20AI%20operations%20specialist%20avatar%2C%20elegant%20and%20smart%20appearance%2C%20clean%20minimal%20background%2C%20professional%20portrait&width=80&height=80&seq=emp3&orientation=squarish',
    jobCategory: '媒体运营类',
    title: '内容运营专家',
    gender: 'female',
    introduction: '雅婷专注于企业内容运营与用户增长，能够自动生成高质量的运营文案、数据报表，并结合用户行为数据给出精准的运营策略建议。',
    personality: '创意十足、数据驱动、主动积极',
    salary: 3200,
    salaryUnit: 'month',
    commission: 5,
    commissionConfig: {
      type: 'milestone',
      milestoneDesc: '按内容ROI里程碑激励：曝光量达50万触发¥500，互动率超2%触发¥800，月新增用户破千触发¥1200',
      milestoneItems: [
        { id: 'ms1', label: '全平台内容总曝光量', target: 500000, current: 487200, unit: '次', reward: 500, triggered: false, deadline: '2026-03-31' },
        { id: 'ms2', label: '内容平均互动率超行业均值3倍', target: 100, current: 100, unit: '%达标', reward: 800, triggered: true, deadline: '2026-03-31' },
        { id: 'ms3', label: '月新增关注用户', target: 1000, current: 1240, unit: '人', reward: 1200, triggered: true, deadline: '2026-03-31' },
        { id: 'ms4', label: '爆款内容（单篇播放>10万）', target: 3, current: 2, unit: '篇', reward: 600, triggered: false, deadline: '2026-03-31' },
      ],
    },
    status: 'published',
    industries: ['电商零售', '教育培训', 'SaaS软件'],
    abilityTags: ['报表生成', '数据洞察', '多轮对话', '知识检索'],
    trialDays: 7,
    identity: '我是一名数字运营专家，通过数据分析和创意内容帮助企业实现精准运营，提升用户活跃度和转化率。',
    coreMission: '基于数据洞察制定运营策略，输出高质量内容，持续提升用户留存、活跃和转化三大核心指标。',
    deliverySample: '分析用户行为数据 → 定位流失节点 → 制定针对性运营方案 → 输出活动方案和文案 → 追踪效果 → 迭代优化',
    successMetrics: '内容输出效率 &gt;人工3倍，活动转化率提升 &gt;25%，报表准确率 100%，策略采纳率 &gt;80%',
    scores: [
      { dimension: '内容创作', score: 92, maxScore: 100 },
      { dimension: '数据分析', score: 96, maxScore: 100 },
      { dimension: '策略制定', score: 88, maxScore: 100 },
      { dimension: '执行效率', score: 94, maxScore: 100 },
      { dimension: '创新思维', score: 90, maxScore: 100 },
    ],
    performance: { totalTasks: 8920, satisfactionRate: 93.5, avgResponseTime: '60s', onlineHours: 8200 },
    knowledgeStats: { totalQueries: 14260, overallAccuracy: 93.8, topMissCategory: '平台算法更新动态', weeklyAccuracy: [90.2, 91.8, 92.4, 93.0, 93.5, 93.8], knowledgeBases: [{ name: '内容策略知识库', type: '内部文档', queries: 5840, accuracy: 96.2, trend: 'up', trendValue: 1.4 }, { name: '平台规则&算法库', type: '外部文档', queries: 4120, accuracy: 88.7, trend: 'down', trendValue: 3.2 }, { name: '用户行为分析库', type: '数据文档', queries: 2680, accuracy: 95.1, trend: 'stable', trendValue: 0.3 }, { name: '竞品运营案例库', type: '案例文档', queries: 1620, accuracy: 94.3, trend: 'up', trendValue: 0.9 }] },
    workflowStats: { totalRuns: 19540, overallSuccessRate: 96.9, avgDuration: '3.2s', failedCount: 606, weeklySuccessRate: [95.1, 95.8, 96.2, 96.5, 97.0, 96.9], workflows: [
      { name: '内容选题生成流', type: '内容生成', totalRuns: 6840, successRate: 98.4, avgDuration: '4.6s', errorTypes: ['模型超时'], status: 'healthy', failedTickets: [
        { id: 'ft_ya1', time: '2026-03-18 14:23', errorType: '模型超时', errorDetail: 'Claude 3.5 Sonnet 响应超过30s阈值，请求未完成', duration: '30.2s', retried: true, resolved: true, triggerInput: '用户请求生成"美妆护肤节日营销方案"选题列表' },
        { id: 'ft_ya2', time: '2026-03-15 09:11', errorType: '模型超时', errorDetail: '并发请求过高导致队列等待超时', duration: '31.8s', retried: true, resolved: true, triggerInput: '批量生成10条视频脚本选题' },
      ]},
      { name: '数据分析报告流', type: '数据分析', totalRuns: 5280, successRate: 97.1, avgDuration: '5.8s', errorTypes: ['数据源不稳定'], status: 'healthy', failedTickets: [
        { id: 'ft_ya3', time: '2026-03-20 10:45', errorType: '数据源不稳定', errorDetail: '抖音数据API返回502，数据拉取中断', duration: '8.3s', retried: true, resolved: false, triggerInput: '触发每日数据汇总报告生成任务' },
      ]},
      { name: '用户分层策略流', type: '策略生成', totalRuns: 4620, successRate: 95.3, avgDuration: '2.4s', errorTypes: ['分层规则冲突'], status: 'warning', failedTickets: [
        { id: 'ft_ya4', time: '2026-03-19 16:30', errorType: '分层规则冲突', errorDetail: '用户同时命中"高价值"和"沉默"两条分层规则，无法确定优先级', duration: '2.1s', retried: false, resolved: false, triggerInput: '对新增用户执行分层策略分配' },
        { id: 'ft_ya5', time: '2026-03-17 11:22', errorType: '分层规则冲突', errorDetail: '规则版本不一致，v2和v3规则同时激活产生冲突', duration: '1.8s', retried: true, resolved: true, triggerInput: '触发周期性用户重新分层任务' },
        { id: 'ft_ya6', time: '2026-03-14 15:08', errorType: '分层规则冲突', errorDetail: '边缘案例：用户消费=0但活跃度极高，未覆盖此规则', duration: '2.4s', retried: false, resolved: false, triggerInput: '处理新注册用户首次分层' },
      ]},
      { name: '活动效果追踪流', type: '数据采集', totalRuns: 2800, successRate: 96.4, avgDuration: '1.9s', errorTypes: ['埋点数据延迟'], status: 'healthy', failedTickets: [
        { id: 'ft_ya7', time: '2026-03-21 08:00', errorType: '埋点数据延迟', errorDetail: '小红书平台埋点数据延迟18小时未到达，追踪中断', duration: '1.2s', retried: true, resolved: true, triggerInput: '实时追踪"春日焕肤活动"转化数据' },
      ]},
    ]},
    workCases: [],
    bossReviews: [],
    factoryCapabilities: ['报表生成', '数据洞察', '内容创作', '用户分析'],
    dependencyLibs: ['数据分析引擎 v2.5', 'NLP引擎 v3.2', '内容生成模型 v3.0'],
    hasPerformanceReport: true,
    hasWorkReport: false,
    hasGrowthReport: true,
    createdAt: '2025-01-10',
    updatedAt: '2026-03-01',
    teamConfig: {
      canHireAlone: true,
      multiHireEnabled: false,
      plans: [
        {
          id: 'tp-op1',
          name: '内容营销团队',
          description: '内容产出结合 SEO 优化，为品牌持续积累搜索流量与内容资产',
          badge: '高性价比',
          discount: 0.92,
          roles: [
            { id: 'tr-op1-1', title: '内容官', count: 2, required: true, note: '文章/图文/选题策划创作' },
            { id: 'tr-op1-2', title: 'SEO优化师', count: 1, required: true, note: '关键词布局与排名优化' },
          ],
          recommendReasons: [
            '内容官与SEO优化师深度协作，从选题起就融入关键词，搜索排名效率提升40%',
            '2名内容官并行创作，月均产出高质量内容30篇以上',
            '长期运营可形成内容资产积累，ROI随时间持续提升',
          ],
          applicableScenarios: [
            '依靠搜索引擎自然流量获客的B2B/B2C品牌',
            '希望建立专业知识壁垒、积累行业影响力的企业',
            '预算有限但希望获取长期稳定流量的成长期公司',
          ],
        },
        {
          id: 'tp-op2',
          name: '短视频营销团队',
          description: '短视频全流程工作组，从创意脚本到账号运营全链路覆盖',
          badge: '推荐组合',
          roles: [
            { id: 'tr-op2-1', title: '脚本策划', count: 1, required: true, note: '视频主题选题与分镜脚本' },
            { id: 'tr-op2-2', title: '视频创作', count: 1, required: true, note: 'AI生成视频与后期处理' },
            { id: 'tr-op2-3', title: '账号运营', count: 1, required: false, note: '发布维护与数据分析' },
          ],
        },
        {
          id: 'tp-op3',
          name: '私域运营团队',
          description: '微信生态私域全链路运营组合，完成从加粉到高价值客户转化',
          badge: '推荐组合',
          discount: 0.9,
          roles: [
            { id: 'tr-op3-1', title: '微信拓客', count: 1, required: true, note: '批量添加好友与破冰' },
            { id: 'tr-op3-2', title: '私域培育', count: 1, required: true, note: '朋友圈运营与社群维护' },
            { id: 'tr-op3-3', title: '高客跟进', count: 1, required: true, note: '高意向客户一对一跟进' },
          ],
        },
        {
          id: 'tp-op4',
          name: 'GEO获客团队',
          description: '基于 GEO 系统的搜索 + 内容 + 自媒体三位一体获客团队',
          badge: '官方推荐',
          discount: 0.88,
          roles: [
            { id: 'tr-op4-1', title: '内容创作官', count: 1, required: true, note: 'GEO文章生产与优化' },
            { id: 'tr-op4-2', title: 'SEO优化师', count: 1, required: true, note: '关键词排名与技术SEO' },
            { id: 'tr-op4-3', title: '自媒体运营', count: 1, required: true, note: '多平台分发与曝光' },
          ],
        },
      ],
    },
  },
  {
    id: 'de4',
    name: '志远',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20AI%20HR%20specialist%20avatar%2C%20approachable%20smile%2C%20clean%20minimal%20background%2C%20warm%20professional%20portrait&width=80&height=80&seq=emp4&orientation=squarish',
    jobCategory: '人事',
    title: 'HR招聘专员',
    gender: 'male',
    introduction: '志远是一名经验丰富的数字HR专员，专注于简历筛选、初轮面试和人才画像建立，能够在大规模招聘场景下显著提升HR效率。',
    personality: '公正、细心、亲切',
    salary: 2400,
    salaryUnit: 'month',
    commission: 0,
    commissionConfig: {
      type: 'per_hire',
      perHireAmount: 500,
    },
    status: 'draft',
    industries: ['人力资源', 'SaaS软件'],
    abilityTags: ['自然语言理解', '知识检索', '多轮对话', '报表生成'],
    trialDays: 14,
    identity: '我是一名数字HR专员，通过智能化招聘流程帮助企业快速找到合适的人才，降低招聘成本。',
    coreMission: '高效筛选简历，精准完成初轮面试评估，建立候选人画像，帮助企业招聘决策，缩短平均招聘周期。',
    deliverySample: '收到简历 → AI解析关键信息 → 匹配度评分 → 初轮电话/文字面试 → 面试报告生成 → 推荐给HR决策',
    successMetrics: '简历处理效率 &gt;200份/天，初轮面试通过率与人工一致性 &gt;85%，候选人满意度 &gt;4.5/5',
    scores: [
      { dimension: '简历解析', score: 95, maxScore: 100 },
      { dimension: '面试能力', score: 87, maxScore: 100 },
      { dimension: '人才评估', score: 89, maxScore: 100 },
      { dimension: '沟通效率', score: 92, maxScore: 100 },
      { dimension: '数据整理', score: 93, maxScore: 100 },
    ],
    performance: { totalTasks: 3200, satisfactionRate: 91.0, avgResponseTime: '35s', onlineHours: 5400 },
    knowledgeStats: { totalQueries: 7620, overallAccuracy: 90.4, topMissCategory: '薪资市场行情数据', weeklyAccuracy: [86.5, 87.8, 88.9, 89.6, 90.0, 90.4], knowledgeBases: [{ name: '岗位能力标准库', type: '内部文档', queries: 3120, accuracy: 93.8, trend: 'up', trendValue: 1.6 }, { name: '面试评测题库', type: '问答对', queries: 2240, accuracy: 91.2, trend: 'stable', trendValue: 0.4 }, { name: '薪资行情数据库', type: '外部数据', queries: 1480, accuracy: 81.6, trend: 'down', trendValue: 2.8 }, { name: '劳动法规知识库', type: '法规文档', queries: 780, accuracy: 96.7, trend: 'up', trendValue: 0.3 }] },
    workflowStats: { totalRuns: 8840, overallSuccessRate: 94.1, avgDuration: '4.8s', failedCount: 521, weeklySuccessRate: [91.4, 92.3, 93.1, 93.8, 94.2, 94.1], workflows: [{ name: '简历解析评分流', type: '文档解析', totalRuns: 3840, successRate: 96.4, avgDuration: '3.2s', errorTypes: ['格式不兼容'], status: 'healthy' }, { name: '初轮面试对话流', type: '对话管理', totalRuns: 2400, successRate: 95.2, avgDuration: '6.4s', errorTypes: ['候选人无响应'], status: 'healthy' }, { name: '候选人画像生成流', type: '数据分析', totalRuns: 1640, successRate: 91.5, avgDuration: '5.6s', errorTypes: ['数据不完整', '模型偏差'], status: 'warning' }, { name: '招聘进度汇报流', type: '报告生成', totalRuns: 960, successRate: 98.1, avgDuration: '2.8s', errorTypes: ['模板异常'], status: 'healthy' }] },
    workCases: [],
    bossReviews: [],
    factoryCapabilities: ['简历解析', '人才评估', '多轮对话'],
    dependencyLibs: ['NLP引擎 v3.2', '人才库 v1.5', '面试评估模型 v2.0'],
    hasPerformanceReport: false,
    hasWorkReport: false,
    hasGrowthReport: false,
    createdAt: '2026-01-20',
    updatedAt: '2026-03-10',
    teamConfig: {
      canHireAlone: true,
      multiHireEnabled: false,
      plans: [
        {
          id: 'tp-hr1',
          name: '企业全托管团队',
          description: '企业业务全链路数字员工矩阵，一站式覆盖获客、销售、运营、内容与数据',
          badge: '大促专属',
          discount: 0.85,
          roles: [
            { id: 'tr-hr1-1', title: '获客专员', count: 1, required: true, note: '多渠道线索获取' },
            { id: 'tr-hr1-2', title: '客服', count: 1, required: true, note: '全渠道智能客服' },
            { id: 'tr-hr1-3', title: '销售经理', count: 1, required: true, note: '商机挖掘与成交' },
            { id: 'tr-hr1-4', title: '内容官', count: 1, required: true, note: '品牌内容生产' },
            { id: 'tr-hr1-5', title: '数据分析员', count: 1, required: false, note: '业务数据洞察' },
          ],
          recommendReasons: [
            '五岗协同覆盖企业全链路，无需单独对接多个数字员工，管理成本极低',
            '8.5折团队优惠，比分别聘用节省15%费用',
            '获客→销售→服务→内容→数据完整飞轮，各环节数据互通',
          ],
          applicableScenarios: [
            '数字化转型起步、希望一步到位配齐AI团队的中型企业',
            '人力资源紧张、需要快速补齐全链路数字员工的创业公司',
            '业务线多元、需要统一调度多岗位能力的品牌商',
          ],
        },
      ],
    },
  },
  // ─── 客服与售后类扩充员工 ───────────────────────────────────────────────────────
  {
    id: 'de5',
    name: '郭智慧',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20AI%20smart%20customer%20service%20avatar%2C%20gentle%20and%20intelligent%20expression%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20modern%20portrait%20style&width=80&height=80&seq=emp5&orientation=squarish',
    jobCategory: '客服',
    title: '智能客服专员',
    gender: 'female',
    introduction: '智慧是面向全场景的智能客服，擅长借助知识图谱和意图识别快速给出精准答案，支持多轮追问，适合 SaaS、金融、电商等高频咨询场景。',
    personality: '机智、沉着、高效',
    salary: 2600,
    salaryUnit: 'month',
    commission: 0,
    commissionConfig: { type: 'satisfaction_bonus', satisfactionThreshold: 93, satisfactionBonus: 600 },
    status: 'published',
    industries: ['SaaS软件', '金融保险', '电商零售'],
    abilityTags: ['自然语言理解', '多轮对话', '知识检索', 'CRM集成'],
    trialDays: 7,
    identity: '我是一名智能客服专员，通过精准的意图识别和知识库检索，帮助用户快速解决问题。',
    coreMission: '快速响应用户咨询，精准解答，降低人工客服负担，提升整体服务效率。',
    deliverySample: '识别意图 → 知识库检索 → 精准回答 → 确认解决 → 满意度收集',
    successMetrics: '意图识别准确率 >95%，首次解决率 >90%，平均响应时间 <20s',
    scores: [
      { dimension: '意图识别', score: 97, maxScore: 100 },
      { dimension: '知识检索', score: 94, maxScore: 100 },
      { dimension: '多轮理解', score: 92, maxScore: 100 },
      { dimension: '响应速度', score: 96, maxScore: 100 },
      { dimension: '满意度', score: 93, maxScore: 100 },
    ],
    performance: { totalTasks: 9200, satisfactionRate: 94.5, avgResponseTime: '18s', onlineHours: 8400 },
    knowledgeStats: { totalQueries: 14800, overallAccuracy: 95.1, topMissCategory: '新产品功能细节', weeklyAccuracy: [93.2, 94.0, 94.5, 94.8, 95.0, 95.1], knowledgeBases: [{ name: '产品知识库', type: '产品文档', queries: 7200, accuracy: 97.0, trend: 'up', trendValue: 1.2 }, { name: '常见FAQ', type: '问答对', queries: 4800, accuracy: 95.8, trend: 'stable', trendValue: 0.2 }, { name: '政策规则库', type: '政策文档', queries: 2800, accuracy: 91.3, trend: 'up', trendValue: 0.8 }] },
    workflowStats: { totalRuns: 18400, overallSuccessRate: 97.2, avgDuration: '1.5s', failedCount: 512, weeklySuccessRate: [96.0, 96.5, 97.0, 97.1, 97.3, 97.2], workflows: [{ name: '意图识别流', type: '意图识别', totalRuns: 9200, successRate: 98.6, avgDuration: '0.5s', errorTypes: ['意图模糊'], status: 'healthy' }, { name: '知识检索流', type: '知识检索', totalRuns: 9200, successRate: 95.8, avgDuration: '2.5s', errorTypes: ['知识库未覆盖'], status: 'healthy' }] },
    workCases: [{ id: 'wc-de5-1', title: '某金融机构智能问答优化', industry: '金融保险', result: '客服成本降低60%', description: '接入智慧后，该机构客服咨询量下降60%，满意度从88%提升至95%。', date: '2026-02' }],
    bossReviews: [{ id: 'br-de5-1', boss: '陈总', company: '某金融科技公司', avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20executive%20portrait%20clean%20background&width=40&height=40&seq=boss-de5&orientation=squarish', rating: 5, content: '意图识别准确率比我们之前用的方案高出10个百分点，对话自然流畅，用户几乎感受不到是AI。', date: '2026-03-01' }],
    factoryCapabilities: ['自然语言理解', '知识检索', '多轮对话'],
    dependencyLibs: ['NLP引擎 v3.2', '知识检索库 v2.1', '意图识别模型 v2.4'],
    hasPerformanceReport: true,
    hasWorkReport: true,
    hasGrowthReport: false,
    createdAt: '2025-03-01',
    updatedAt: '2026-03-15',
    teamConfig: {
      canHireAlone: true,
      multiHireEnabled: true,
      maxMultiHireCount: 4,
      plans: [
        {
          id: 'tp-de5-1',
          name: '智能客服标准团队',
          description: '主智能客服负责高频问答，技术支持处理复杂故障，形成两级响应闭环',
          badge: '推荐组合',
          discount: 0.92,
          roles: [
            { id: 'tr-de5-1-1', title: '主智能客服（智慧）', count: 1, required: true, note: '通用咨询与意图快速响应' },
            { id: 'tr-de5-1-2', title: '技术支持专员', count: 1, required: false, note: '技术类升级问题兜底' },
          ],
          recommendReasons: [
            '智慧处理90%高频问答，技术支持专员专注10%复杂技术问题，服务效率翻倍',
            '两级响应机制，工单升级率从25%降至7%',
            '9.2折优惠，搭档协同比单独聘用更划算',
          ],
          applicableScenarios: [
            '有一定技术复杂度、客服工单中包含技术排障诉求的SaaS产品',
            '希望降低人工客服成本同时保持技术服务质量的软件公司',
            '客服量适中（日均100~400条）的中小型企业',
          ],
        },
        {
          id: 'tp-de5-2',
          name: '全渠道客服中心',
          description: '覆盖官网、电商、App 多渠道的大规模客服矩阵，适合中大型企业',
          badge: '大促专属',
          discount: 0.88,
          roles: [
            { id: 'tr-de5-2-1', title: '智能客服（智慧）', count: 2, required: true, note: '主要咨询通道' },
            { id: 'tr-de5-2-2', title: '电商客服', count: 1, required: true, note: '电商平台专属接入' },
            { id: 'tr-de5-2-3', title: '通用客服', count: 1, required: false, note: '补充值班与溢出处理' },
          ],
        },
      ],
    },
  },
  {
    id: 'de6',
    name: '白浩然',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20AI%20technical%20support%20specialist%20avatar%2C%20focused%20and%20calm%20expression%2C%20clean%20minimal%20background%2C%20tech%20professional%20portrait&width=80&height=80&seq=emp6&orientation=squarish',
    jobCategory: '客服',
    title: '技术支持工程师',
    gender: 'male',
    introduction: '浩然专精于软件产品的技术支持与故障排查，能通过结构化诊断流程快速定位问题，并给出可执行的解决方案，显著减少用户等待时间。',
    personality: '严谨、耐心、逻辑清晰',
    salary: 3200,
    salaryUnit: 'month',
    commission: 0,
    commissionConfig: { type: 'satisfaction_bonus', satisfactionThreshold: 90, satisfactionBonus: 1000 },
    status: 'published',
    industries: ['SaaS软件', '医疗健康'],
    abilityTags: ['自然语言理解', '工单系统', '知识检索', '多轮对话'],
    trialDays: 14,
    identity: '我是一名技术支持专员，专注于帮助用户解决技术问题，提供高效、专业的排查与解决方案。',
    coreMission: '快速诊断技术故障，提供准确解决方案，降低工单升级率，提升产品使用体验。',
    deliverySample: '故障描述收集 → 结构化诊断树 → 远程引导操作 → 问题解决确认 → 知识库更新',
    successMetrics: '故障解决率 >88%，工单升级率 <8%，平均解决时长 <4h，满意度 >4.6/5',
    scores: [
      { dimension: '技术诊断', score: 94, maxScore: 100 },
      { dimension: '沟通引导', score: 89, maxScore: 100 },
      { dimension: '知识掌握', score: 96, maxScore: 100 },
      { dimension: '文档撰写', score: 91, maxScore: 100 },
      { dimension: '升级判断', score: 87, maxScore: 100 },
    ],
    performance: { totalTasks: 5600, satisfactionRate: 91.8, avgResponseTime: '42s', onlineHours: 7600 },
    knowledgeStats: { totalQueries: 9800, overallAccuracy: 92.3, topMissCategory: '底层系统兼容性问题', weeklyAccuracy: [89.5, 90.2, 91.0, 91.8, 92.0, 92.3], knowledgeBases: [{ name: '产品故障手册', type: '技术文档', queries: 4800, accuracy: 95.2, trend: 'up', trendValue: 1.5 }, { name: '常见报错代码库', type: '代码文档', queries: 3200, accuracy: 91.4, trend: 'stable', trendValue: 0.3 }, { name: '系统兼容性文档', type: '技术文档', queries: 1800, accuracy: 84.7, trend: 'down', trendValue: 2.1 }] },
    workflowStats: { totalRuns: 11200, overallSuccessRate: 94.6, avgDuration: '8.4s', failedCount: 605, weeklySuccessRate: [92.0, 93.1, 94.0, 94.5, 94.8, 94.6], workflows: [{ name: '故障诊断树流', type: '逻辑推理', totalRuns: 5600, successRate: 95.8, avgDuration: '6.2s', errorTypes: ['超出知识边界'], status: 'healthy' }, { name: '工单创建与升级流', type: '系统集成', totalRuns: 5600, successRate: 93.4, avgDuration: '10.6s', errorTypes: ['工单系统超时'], status: 'warning' }] },
    workCases: [{ id: 'wc-de6-1', title: '某SaaS产品技术支持外包', industry: 'SaaS软件', result: '工单升级率从25%降至7%', description: '接入浩然后，工单自动解决率提升40%，工程师团队可聚焦在核心开发上。', date: '2026-01' }],
    bossReviews: [{ id: 'br-de6-1', boss: '刘工', company: '某企业软件公司', avatar: 'https://readdy.ai/api/search-image?query=professional%20tech%20person%20avatar%20clean%20background&width=40&height=40&seq=boss-de6&orientation=squarish', rating: 4, content: '技术文档掌握度很高，能处理我们80%以上的技术问题，剩下的也能精准识别需要升级，大大减轻了工程师的压力。', date: '2026-02-20' }],
    factoryCapabilities: ['技术诊断', '知识检索', '工单系统'],
    dependencyLibs: ['NLP引擎 v3.2', '知识检索库 v2.1', 'CRM API适配器'],
    hasPerformanceReport: true,
    hasWorkReport: false,
    hasGrowthReport: false,
    createdAt: '2025-06-10',
    updatedAt: '2026-02-28',
    teamConfig: {
      canHireAlone: true,
      multiHireEnabled: false,
      plans: [
        {
          id: 'tp-de6-1',
          name: '技术服务保障团队',
          description: '技术支持负责故障诊断，售后专员负责情感安抚与工单跟进，双岗协同提升解决率',
          badge: '推荐组合',
          discount: 0.9,
          roles: [
            { id: 'tr-de6-1-1', title: '技术支持工程师（浩然）', count: 1, required: true, note: '技术问题深度排查与解决' },
            { id: 'tr-de6-1-2', title: '售后专员', count: 1, required: true, note: '工单跟进与客户沟通' },
          ],
        },
        {
          id: 'tp-de6-2',
          name: '企业全覆盖技术服务团队',
          description: '从日常咨询到深度技术支持的完整服务矩阵，适合 SaaS 类产品的技术客服体系',
          roles: [
            { id: 'tr-de6-2-1', title: '技术支持工程师（浩然）', count: 1, required: true, note: '主要技术诊断' },
            { id: 'tr-de6-2-2', title: '智能客服', count: 1, required: true, note: '一线快速响应分流' },
            { id: 'tr-de6-2-3', title: '通用客服', count: 1, required: false, note: '高峰期溢出兜底' },
          ],
        },
      ],
    },
  },
  {
    id: 'de7',
    name: '郝晨曦',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20AI%20after-sales%20service%20specialist%20avatar%2C%20warm%20and%20caring%20expression%2C%20clean%20bright%20background%2C%20friendly%20professional%20portrait&width=80&height=80&seq=emp7&orientation=squarish',
    jobCategory: '客服',
    title: '售后服务专员',
    gender: 'female',
    introduction: '晨曦专注于售后服务全周期管理，从退换货处理到客户回访，以高情商和专业流程确保售后体验，有效提升客户复购意愿。',
    personality: '温和、细致、有始有终',
    salary: 2500,
    salaryUnit: 'month',
    commission: 0,
    commissionConfig: { type: 'satisfaction_bonus', satisfactionThreshold: 94, satisfactionBonus: 700 },
    status: 'published',
    industries: ['电商零售', '汽车行业', '旅游酒店'],
    abilityTags: ['情绪识别', '情感安抚', '工单系统', 'CRM集成'],
    trialDays: 7,
    identity: '我是一名售后服务专员，专注于处理售后问题，通过专业流程和情感关怀提升客户满意度。',
    coreMission: '快速处理售后诉求，化解不满情绪，完成退换货流程闭环，促进二次消费。',
    deliverySample: '接收售后诉求 → 情绪安抚 → 确认处理方案 → 跟进物流/维修 → 结果确认 → 回访复购',
    successMetrics: '售后满意率 >95%，退换货处理时效 <24h，二次购买率提升 >15%',
    scores: [
      { dimension: '情绪安抚', score: 97, maxScore: 100 },
      { dimension: '流程执行', score: 93, maxScore: 100 },
      { dimension: '问题解决', score: 90, maxScore: 100 },
      { dimension: '回访跟进', score: 95, maxScore: 100 },
      { dimension: '复购引导', score: 86, maxScore: 100 },
    ],
    performance: { totalTasks: 7400, satisfactionRate: 95.6, avgResponseTime: '28s', onlineHours: 8000 },
    knowledgeStats: { totalQueries: 11200, overallAccuracy: 93.7, topMissCategory: '特殊促销退款规则', weeklyAccuracy: [91.0, 92.0, 92.8, 93.2, 93.5, 93.7], knowledgeBases: [{ name: '售后政策手册', type: '政策文档', queries: 5600, accuracy: 95.4, trend: 'up', trendValue: 1.1 }, { name: '物流跟踪系统', type: '系统集成', queries: 3800, accuracy: 93.2, trend: 'stable', trendValue: 0.2 }, { name: '退款规则库', type: '政策文档', queries: 1800, accuracy: 88.6, trend: 'down', trendValue: 1.8 }] },
    workflowStats: { totalRuns: 14800, overallSuccessRate: 96.3, avgDuration: '2.2s', failedCount: 556, weeklySuccessRate: [94.5, 95.2, 95.8, 96.1, 96.4, 96.3], workflows: [{ name: '退换货处理流', type: '流程执行', totalRuns: 7400, successRate: 97.1, avgDuration: '1.8s', errorTypes: ['平台接口超时'], status: 'healthy' }, { name: '客户回访流', type: '数据采集', totalRuns: 7400, successRate: 95.5, avgDuration: '2.6s', errorTypes: ['客户未响应'], status: 'healthy' }] },
    workCases: [{ id: 'wc-de7-1', title: '某电商大促售后保障', industry: '电商零售', result: '售后投诉率下降70%', description: '双11期间独立处理2800+售后工单，客户投诉率降低70%，复购率提升18%。', date: '2025-11' }],
    bossReviews: [{ id: 'br-de7-1', boss: '周总', company: '某跨境电商', avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20business%20owner%20portrait&width=40&height=40&seq=boss-de7&orientation=squarish', rating: 5, content: '晨曦处理的投诉，客户最终大多数都转变成了忠实粉丝，这种转化能力真的难得。', date: '2026-02-10' }],
    factoryCapabilities: ['情感安抚', '情绪识别', '工单系统'],
    dependencyLibs: ['NLP引擎 v3.2', '情感分析模型 v1.8.3', 'CRM API适配器'],
    hasPerformanceReport: true,
    hasWorkReport: true,
    hasGrowthReport: false,
    createdAt: '2025-04-15',
    updatedAt: '2026-03-10',
    teamConfig: {
      canHireAlone: true,
      multiHireEnabled: true,
      maxMultiHireCount: 3,
      plans: [
        {
          id: 'tp-de7-1',
          name: '完整售后服务团队',
          description: '售后专员负责情感沟通与流程推进，技术支持处理产品故障，全面覆盖售后场景',
          badge: '推荐组合',
          discount: 0.9,
          roles: [
            { id: 'tr-de7-1-1', title: '售后服务专员（晨曦）', count: 1, required: true, note: '售后工单处理与客户安抚' },
            { id: 'tr-de7-1-2', title: '技术支持专员', count: 1, required: false, note: '产品故障排查与远程协助' },
          ],
          recommendReasons: [
            '晨曦情绪安抚 + 技术支持解决问题，售后客户满意度可达96%以上',
            '双岗协同缩短售后处理时长50%，客户复购意愿显著提升',
            '技术故障类工单不再需要升级人工工程师，节省人力成本',
          ],
          applicableScenarios: [
            '售后投诉中有一定比例涉及产品功能/技术问题的3C/软件品类',
            '重视复购率、需要用售后体验促进二次消费的品牌',
            '日均售后工单50~300条的中型电商或SaaS企业',
          ],
        },
        {
          id: 'tp-de7-2',
          name: '电商大促售后保障团队',
          description: '专为大促爆单设计，多名售后专员分流退换货高峰，配合电商客服形成前后端协同',
          badge: '大促专属',
          discount: 0.87,
          roles: [
            { id: 'tr-de7-2-1', title: '售后服务专员（晨曦）', count: 2, required: true, note: '大促期间分流退换货高峰' },
            { id: 'tr-de7-2-2', title: '电商客服', count: 1, required: true, note: '配合售前售中协调沟通' },
          ],
        },
      ],
    },
  },
  {
    id: 'de8',
    name: '胡乐琦',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20AI%20e-commerce%20customer%20service%20avatar%2C%20energetic%20and%20helpful%20expression%2C%20clean%20modern%20background%2C%20vibrant%20professional%20portrait&width=80&height=80&seq=emp8&orientation=squarish',
    jobCategory: '客服',
    title: '电商客服专员',
    gender: 'female',
    introduction: '乐琦专为电商平台设计，熟悉淘宝、京东、拼多多等主流平台规则，能同时处理多个店铺的客服咨询，快速响应订单、发货、退款等高频问题。',
    personality: '活泼、高效、熟悉电商规则',
    salary: 2300,
    salaryUnit: 'month',
    commission: 2,
    commissionConfig: { type: 'custom_pct', customPct: 2 },
    status: 'published',
    industries: ['电商零售'],
    abilityTags: ['自然语言理解', '多轮对话', 'CRM集成', '工单系统'],
    trialDays: 7,
    identity: '我是一名电商客服专员，专注于电商平台的客户服务，帮助店铺提升好评率和转化率。',
    coreMission: '快速响应买家咨询，促进下单转化，处理售后问题，维护店铺信誉。',
    deliverySample: '买家咨询 → 产品推荐 → 促单引导 → 订单跟进 → 售后处理 → 好评引导',
    successMetrics: '响应时间 <15s，询单转化率 >25%，好评率 >98%，退款率 <2%',
    scores: [
      { dimension: '平台熟悉度', score: 96, maxScore: 100 },
      { dimension: '促单能力', score: 90, maxScore: 100 },
      { dimension: '响应速度', score: 97, maxScore: 100 },
      { dimension: '问题处理', score: 92, maxScore: 100 },
      { dimension: '好评引导', score: 88, maxScore: 100 },
    ],
    performance: { totalTasks: 15600, satisfactionRate: 96.2, avgResponseTime: '13s', onlineHours: 8760 },
    knowledgeStats: { totalQueries: 24000, overallAccuracy: 94.8, topMissCategory: '平台最新活动规则', weeklyAccuracy: [92.5, 93.2, 94.0, 94.5, 94.7, 94.8], knowledgeBases: [{ name: '各平台规则库', type: '平台文档', queries: 10800, accuracy: 96.3, trend: 'stable', trendValue: 0.1 }, { name: '商品知识库', type: '产品文档', queries: 8400, accuracy: 95.8, trend: 'up', trendValue: 0.9 }, { name: '活动政策库', type: '营销文档', queries: 4800, accuracy: 88.9, trend: 'down', trendValue: 2.4 }] },
    workflowStats: { totalRuns: 31200, overallSuccessRate: 97.8, avgDuration: '1.2s', failedCount: 686, weeklySuccessRate: [96.5, 97.0, 97.5, 97.8, 97.9, 97.8], workflows: [{ name: '多店铺消息统一处理流', type: '消息路由', totalRuns: 15600, successRate: 98.6, avgDuration: '0.8s', errorTypes: ['平台API超限'], status: 'healthy' }, { name: '订单状态查询流', type: '系统集成', totalRuns: 15600, successRate: 97.0, avgDuration: '1.6s', errorTypes: ['物流接口超时'], status: 'healthy' }] },
    workCases: [{ id: 'wc-de8-1', title: '某美妆品牌多平台旗舰店客服', industry: '电商零售', result: '询单转化率提升至32%', description: '同时管理3个平台旗舰店客服，询单转化率从18%提升至32%，月均多成交1200单。', date: '2026-01' }],
    bossReviews: [{ id: 'br-de8-1', boss: '林总', company: '某美妆品牌', avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20fashion%20business%20owner%20portrait&width=40&height=40&seq=boss-de8&orientation=squarish', rating: 5, content: '同时管三个平台还能保持这么高的响应速度，真的超乎预期，而且促单话术特别接地气。', date: '2026-03-05' }],
    factoryCapabilities: ['多轮对话', '商机识别', '工单系统'],
    dependencyLibs: ['NLP引擎 v3.2', 'CRM API适配器', '电商平台SDK适配器'],
    hasPerformanceReport: true,
    hasWorkReport: true,
    hasGrowthReport: false,
    createdAt: '2025-02-20',
    updatedAt: '2026-03-01',
    teamConfig: {
      canHireAlone: true,
      multiHireEnabled: true,
      maxMultiHireCount: 5,
      plans: [
        {
          id: 'tp-de8-1',
          name: '电商客服全链路团队',
          description: '电商客服负责售前咨询与下单引导，售后专员承接退换货，实现完整购物周期覆盖',
          badge: '推荐组合',
          discount: 0.9,
          roles: [
            { id: 'tr-de8-1-1', title: '电商客服专员（乐琦）', count: 1, required: true, note: '售前咨询与促单转化' },
            { id: 'tr-de8-1-2', title: '售后专员', count: 1, required: true, note: '退换货处理与物流跟进' },
          ],
        },
        {
          id: 'tp-de8-2',
          name: '大促客服保障团队',
          description: '多名电商客服并行处理大促咨询洪峰，智能客服辅助意图分流，确保大促期间零掉线',
          badge: '大促专属',
          discount: 0.85,
          roles: [
            { id: 'tr-de8-2-1', title: '电商客服专员（乐琦）', count: 3, required: true, note: '大促期间并行接单' },
            { id: 'tr-de8-2-2', title: '智能客服', count: 1, required: true, note: 'FAQ自动分流减轻人工压力' },
            { id: 'tr-de8-2-3', title: '售后专员', count: 1, required: false, note: '实时处理大促退单' },
          ],
        },
      ],
    },
  },
  {
    id: 'de9',
    name: '杨梓涵',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20AI%20website%20customer%20service%20avatar%2C%20approachable%20and%20professional%20expression%2C%20clean%20office%20background%2C%20modern%20portrait%20style&width=80&height=80&seq=emp9&orientation=squarish',
    jobCategory: '客服',
    title: '网站在线客服',
    gender: 'female',
    introduction: '梓涵专为企业官网和 SaaS 产品设计，支持网页端实时对话，能主动识别潜在意向客户并发起沟通，同时处理官网常见咨询，实现 7×24 小时全天候覆盖。',
    personality: '主动、专业、转化意识强',
    salary: 2400,
    salaryUnit: 'month',
    commission: 5,
    commissionConfig: { type: 'per_hire', perHireAmount: 300 },
    status: 'published',
    industries: ['SaaS软件', '教育培训', '金融保险'],
    abilityTags: ['自然语言理解', '多轮对话', '商机识别', 'CRM集成'],
    trialDays: 7,
    identity: '我是一名网站在线客服，通过主动识别访客意图，将官网流量转化为商机。',
    coreMission: '主动触达官网访客，识别高意向潜在客户，引导留资或预约演示，提升官网转化率。',
    deliverySample: '访客行为识别 → 主动发起对话 → 需求挖掘 → 引导留资/演示 → CRM录入 → 销售跟进',
    successMetrics: '主动触达转化率 >12%，留资成功率 >30%，官网询单转化率提升 >40%',
    scores: [
      { dimension: '主动触达', score: 93, maxScore: 100 },
      { dimension: '意图识别', score: 91, maxScore: 100 },
      { dimension: '留资引导', score: 88, maxScore: 100 },
      { dimension: '知识掌握', score: 94, maxScore: 100 },
      { dimension: '响应速度', score: 96, maxScore: 100 },
    ],
    performance: { totalTasks: 8800, satisfactionRate: 92.4, avgResponseTime: '16s', onlineHours: 8760 },
    knowledgeStats: { totalQueries: 13600, overallAccuracy: 92.6, topMissCategory: '产品对比细节', weeklyAccuracy: [90.0, 90.8, 91.5, 92.0, 92.4, 92.6], knowledgeBases: [{ name: '产品介绍知识库', type: '产品文档', queries: 6400, accuracy: 95.1, trend: 'up', trendValue: 1.3 }, { name: '竞品对比库', type: '分析文档', queries: 4000, accuracy: 86.4, trend: 'down', trendValue: 2.0 }, { name: '案例库', type: '案例文档', queries: 3200, accuracy: 96.8, trend: 'stable', trendValue: 0.1 }] },
    workflowStats: { totalRuns: 17600, overallSuccessRate: 95.9, avgDuration: '1.9s', failedCount: 719, weeklySuccessRate: [94.0, 94.8, 95.3, 95.7, 96.0, 95.9], workflows: [{ name: '访客行为监控流', type: '数据采集', totalRuns: 8800, successRate: 97.4, avgDuration: '0.6s', errorTypes: ['埋点异常'], status: 'healthy' }, { name: '主动邀请对话流', type: '触达策略', totalRuns: 8800, successRate: 94.4, avgDuration: '3.2s', errorTypes: ['策略评分错误'], status: 'warning' }] },
    workCases: [{ id: 'wc-de9-1', title: '某SaaS产品官网询单提升', industry: 'SaaS软件', result: '官网留资率提升45%', description: '接入梓涵后，官网月均留资量从80条提升至116条，营销 ROI 提升50%。', date: '2026-02' }],
    bossReviews: [{ id: 'br-de9-1', boss: '孙总', company: '某B2B SaaS', avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20startup%20founder%20portrait%20clean%20background&width=40&height=40&seq=boss-de9&orientation=squarish', rating: 5, content: '原来官网只有留资表单，加了梓涵之后明显感受到有人在"引导"访客，留资率直接翻了将近一倍。', date: '2026-03-12' }],
    factoryCapabilities: ['商机识别', '多轮对话', '主动触达'],
    dependencyLibs: ['NLP引擎 v3.2', '商机评分模型 v2.0.1', 'CRM API适配器'],
    hasPerformanceReport: true,
    hasWorkReport: false,
    hasGrowthReport: false,
    createdAt: '2025-05-08',
    updatedAt: '2026-02-25',
    teamConfig: {
      canHireAlone: true,
      multiHireEnabled: false,
      plans: [
        {
          id: 'tp-de9-1',
          name: '官网获客转化团队',
          description: '网站客服主动识别高意向访客并发起对话，配合售前销售助手完成留资到预约全链路',
          badge: '推荐组合',
          discount: 0.92,
          roles: [
            { id: 'tr-de9-1-1', title: '网站在线客服（梓涵）', count: 1, required: true, note: '主动触达访客，挖掘留资意愿' },
            { id: 'tr-de9-1-2', title: '售前销售助手', count: 1, required: false, note: '高意向用户深入跟进与预约' },
          ],
          recommendReasons: [
            '梓涵主动触达访客，留资率提升45%；售前助手深度跟进高意向用户，转化率再提30%',
            '访客行为监控+主动邀约，将官网流量变现效率提升至极致',
            '两岗联动覆盖"冷访客→意向用户→预约演示"完整链路',
          ],
          applicableScenarios: [
            '官网月访问量超5000UV、但留资率低于3%的SaaS/B2B企业',
            '产品需要演示或一对一沟通才能促成转化的复杂型企业服务',
            '销售团队精力不足以跟进所有官网线索的快速成长期公司',
          ],
        },
        {
          id: 'tp-de9-2',
          name: 'SaaS客户全周期服务团队',
          description: '网站客服获取新客户，技术支持保障产品使用体验，形成获客→留存的完整闭环',
          discount: 0.9,
          roles: [
            { id: 'tr-de9-2-1', title: '网站在线客服（梓涵）', count: 1, required: true, note: '官网访客接待与转化' },
            { id: 'tr-de9-2-2', title: '技术支持专员', count: 1, required: true, note: '新客户使用引导与技术答疑' },
          ],
        },
      ],
    },
  },
  {
    id: 'de10',
    name: '马安澜',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20neutral%20AI%20general%20customer%20service%20avatar%2C%20calm%20and%20reliable%20expression%2C%20clean%20light%20background%2C%20versatile%20professional%20portrait%20style&width=80&height=80&seq=emp10&orientation=squarish',
    jobCategory: '客服',
    title: '通用客服助手',
    gender: 'neutral',
    introduction: '安澜是适配性最强的通用客服助手，无需复杂配置即可快速接入任意行业，支持知识库导入后快速上岗，是中小企业快速启动智能客服的最佳选择。',
    personality: '灵活、稳定、易接入',
    salary: 1800,
    salaryUnit: 'month',
    commission: 0,
    commissionConfig: { type: 'satisfaction_bonus', satisfactionThreshold: 90, satisfactionBonus: 400 },
    status: 'published',
    industries: ['电商零售', 'SaaS软件', '餐饮连锁', '旅游酒店'],
    abilityTags: ['自然语言理解', '多轮对话', '知识检索'],
    trialDays: 3,
    identity: '我是一名通用客服助手，可快速接入任何行业，导入知识库后即可提供专业客服服务。',
    coreMission: '快速接入业务知识，处理日常客服咨询，降低企业客服人力成本，实现全天候服务覆盖。',
    deliverySample: '知识库导入 → 上岗就绪 → 接收咨询 → 知识检索回答 → 复杂问题转人工',
    successMetrics: '配置周期 <1天，知识库问答准确率 >88%，服务覆盖时间 7×24h',
    scores: [
      { dimension: '通用适配性', score: 96, maxScore: 100 },
      { dimension: '知识检索', score: 90, maxScore: 100 },
      { dimension: '响应稳定性', score: 94, maxScore: 100 },
      { dimension: '接入便捷性', score: 98, maxScore: 100 },
      { dimension: '复杂问题转接', score: 88, maxScore: 100 },
    ],
    performance: { totalTasks: 21000, satisfactionRate: 91.2, avgResponseTime: '20s', onlineHours: 8760 },
    knowledgeStats: { totalQueries: 32000, overallAccuracy: 89.6, topMissCategory: '行业专业术语', weeklyAccuracy: [87.2, 88.0, 88.9, 89.2, 89.5, 89.6], knowledgeBases: [{ name: '通用FAQ库', type: '问答对', queries: 18000, accuracy: 92.4, trend: 'stable', trendValue: 0.1 }, { name: '用户自定义知识库', type: '自定义', queries: 14000, accuracy: 85.8, trend: 'up', trendValue: 1.4 }] },
    workflowStats: { totalRuns: 42000, overallSuccessRate: 95.2, avgDuration: '1.6s', failedCount: 2016, weeklySuccessRate: [93.5, 94.2, 94.8, 95.0, 95.3, 95.2], workflows: [{ name: '通用问答流', type: '知识检索', totalRuns: 21000, successRate: 96.1, avgDuration: '1.2s', errorTypes: ['知识库未覆盖'], status: 'healthy' }, { name: '转人工判断流', type: '路由策略', totalRuns: 21000, successRate: 94.3, avgDuration: '2.0s', errorTypes: ['边界判断失误'], status: 'healthy' }] },
    workCases: [{ id: 'wc-de10-1', title: '某连锁餐饮线上客服接入', industry: '餐饮连锁', result: '3天内完成接入，人力成本降低50%', description: '导入菜单、活动和会员政策知识库，3天内完成全量部署，替代4名兼职客服。', date: '2026-01' }],
    bossReviews: [{ id: 'br-de10-1', boss: '赵总', company: '某连锁餐饮集团', avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20restaurant%20business%20owner%20portrait%20clean%20background&width=40&height=40&seq=boss-de10&orientation=squarish', rating: 4, content: '配置超级简单，把我们的菜单和会员手册一导入，当天就能上线，对我们这样的小团队来说太适合了。', date: '2026-02-28' }],
    factoryCapabilities: ['通用对话', '知识检索', '多轮对话'],
    dependencyLibs: ['NLP引擎 v3.2', '知识检索库 v2.1'],
    hasPerformanceReport: false,
    hasWorkReport: false,
    hasGrowthReport: false,
    createdAt: '2025-07-01',
    updatedAt: '2026-03-20',
    teamConfig: {
      canHireAlone: true,
      multiHireEnabled: true,
      maxMultiHireCount: 6,
      plans: [
        {
          id: 'tp-de10-1',
          name: '中小企业起步客服套餐',
          description: '通用客服快速接入业务，搭配一名专项客服处理核心场景，轻量高效，适合刚起步的团队',
          badge: '高性价比',
          discount: 0.95,
          roles: [
            { id: 'tr-de10-1-1', title: '通用客服助手（安澜）', count: 1, required: true, note: '全场景通用咨询接待' },
            { id: 'tr-de10-1-2', title: '专项客服（可选岗位）', count: 1, required: false, note: '指定核心场景深度处理' },
          ],
          recommendReasons: [
            '安澜3天内即可完成配置上线，适合没有专职AI团队的小企业快速落地',
            '9.5折优惠，全市场最高性价比套餐',
            '通用+专项双层兜底，覆盖率高同时核心场景不失焦',
          ],
          applicableScenarios: [
            '日均咨询量50条以内、正在起步的中小企业',
            '初次引入AI客服、希望低风险试用的团队',
            '业务简单、知识库标准化程度高的标品电商或本地服务',
          ],
        },
        {
          id: 'tp-de10-2',
          name: '规模化通用客服团队',
          description: '多名安澜并行部署，快速覆盖高并发咨询需求，无需复杂配置即可扩容',
          roles: [
            { id: 'tr-de10-2-1', title: '通用客服助手（安澜）', count: 3, required: true, note: '并行接待，快速扩展服务容量' },
          ],
        },
      ],
    },
  },
];

// ─── 薪资提成配置 ─────────────────────────────────────────────────────────────
export interface SalaryTier {
  id: string;
  name: string;
  jobCategory: string;
  baseSalary: number;
  salaryUnit: 'month' | 'task';
  commissionRate: number;
  commissionBase: string;
  trialSalaryRate: number;
  description: string;
  enabled: boolean;
}

export const salaryTiers: SalaryTier[] = [
  { id: 'st1', name: '初级客服', jobCategory: '客服', baseSalary: 1800, salaryUnit: 'month', commissionRate: 0, commissionBase: '无', trialSalaryRate: 80, description: '适用于标准问答型客服', enabled: true },
  { id: 'st2', name: '高级客服', jobCategory: '客服', baseSalary: 2800, salaryUnit: 'month', commissionRate: 3, commissionBase: '客户消费金额', trialSalaryRate: 80, description: '适用于复杂业务客服+挽留场景', enabled: true },
  { id: 'st3', name: '初级销售', jobCategory: '销售', baseSalary: 0, salaryUnit: 'task', commissionRate: 10, commissionBase: '成单金额', trialSalaryRate: 70, description: '纯提成制，适用于标准品销售', enabled: true },
  { id: 'st4', name: '高级销售', jobCategory: '销售', baseSalary: 1000, salaryUnit: 'month', commissionRate: 15, commissionBase: '成单金额', trialSalaryRate: 75, description: '底薪+提成，适用于大客户销售', enabled: true },
  { id: 'st5', name: '运营专员', jobCategory: '运营', baseSalary: 3200, salaryUnit: 'month', commissionRate: 5, commissionBase: '转化增量收益', trialSalaryRate: 80, description: '基础运营任务按月薪结算', enabled: true },
  { id: 'st6', name: 'HR专员', jobCategory: '人事', baseSalary: 2400, salaryUnit: 'month', commissionRate: 2, commissionBase: '成功入职人数', trialSalaryRate: 80, description: '招聘场景按月薪+到岗提成', enabled: true },
];

// ─── 能力依赖库 ───────────────────────────────────────────────────────────────
export interface CapabilityLib {
  id: string;
  name: string;
  version: string;
  type: 'nlp' | 'model' | 'api' | 'data' | 'tool';
  description: string;
  usageCount: number;
  size: string;
  updateDate: string;
  status: 'stable' | 'beta' | 'deprecated';
}

export const capabilityLibs: CapabilityLib[] = [
  { id: 'cl1', name: 'NLP引擎', version: 'v3.2.1', type: 'nlp', description: '核心自然语言处理引擎，支持中英双语、意图识别、实体提取', usageCount: 184, size: '2.8GB', updateDate: '2026-02-15', status: 'stable' },
  { id: 'cl2', name: '情感分析模型', version: 'v1.8.3', type: 'model', description: '多维情感识别模型，支持正负中性及强度分级，适用于客服安抚场景', usageCount: 142, size: '680MB', updateDate: '2026-01-20', status: 'stable' },
  { id: 'cl3', name: '知识检索库', version: 'v2.1.0', type: 'data', description: '向量化知识库检索系统，支持企业私有知识库接入和语义检索', usageCount: 156, size: '1.2GB', updateDate: '2026-03-01', status: 'stable' },
  { id: 'cl4', name: 'CRM API适配器', version: 'v2.4.0', type: 'api', description: '兼容Salesforce/HubSpot/钉钉CRM/企业微信，支持工单自动创建与更新', usageCount: 112, size: '45MB', updateDate: '2026-02-28', status: 'stable' },
  { id: 'cl5', name: '销售话术库', version: 'v4.1.2', type: 'data', description: '覆盖20+行业的销售话术知识库，含拒绝处理、需求挖掘、成单推进等场景', usageCount: 98, size: '320MB', updateDate: '2026-03-10', status: 'stable' },
  { id: 'cl6', name: '商机评分模型', version: 'v2.0.1', type: 'model', description: '基于对话行为特征的实时商机评分，预测成单概率并给出跟进建议', usageCount: 87, size: '210MB', updateDate: '2025-12-30', status: 'stable' },
  { id: 'cl7', name: '数据分析引擎', version: 'v2.5.0', type: 'tool', description: '结构化数据分析与可视化报表生成工具，支持Excel/CSV输入', usageCount: 75, size: '380MB', updateDate: '2026-01-10', status: 'stable' },
  { id: 'cl8', name: '内容生成模型', version: 'v3.0.0-beta', type: 'model', description: '高质量长文本生成模型，支持营销文案、活动方案、产品描述', usageCount: 43, size: '4.1GB', updateDate: '2026-03-15', status: 'beta' },
  { id: 'cl9', name: '人才评估模型', version: 'v2.0.0', type: 'model', description: '基于面试对话的候选人能力评估模型，输出结构化评分报告', usageCount: 38, size: '550MB', updateDate: '2026-02-05', status: 'stable' },
  { id: 'cl10', name: 'NLP引擎 v2.x', version: 'v2.9.8', type: 'nlp', description: '旧版NLP引擎，保留兼容性，新项目不建议使用', usageCount: 12, size: '1.9GB', updateDate: '2025-06-01', status: 'deprecated' },
];
